module.exports = __webpack_public_path__ + "static/media/bills.e00fd55b.svg";